<template>
  <v-menu
    left
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="500"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on"></slot>
    </template>
    <v-card>
      <v-card-title>Adicionando fornecedor</v-card-title>
      <v-card-text class="text--primary">
        <v-row>
          <v-col cols="12">
            <px-autocomplete-fornecedor v-model="fornecedor"
                                        path="fornecedor/score"
                                        show-codigo
                                        class="required rounded-tag-small"
                                        :error="$v.fornecedor.$error"
                                        @blur="$v.fornecedor.$touch()"
                                        required/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               :loading="loading"
               :disabled="$v.$invalid"
               @click="save">
          Enviar
        </v-btn>
        <v-btn @click="close" text class="normal-btn-text">
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import CotacaoService from '../cotacao-service';

export default {
  props: {
    cotacao: Object,
  },
  data() {
    return {
      menuOpened: false,
      loading: false,
      fornecedor: null,
    };
  },
  methods: {
    close() {
      this.menuOpened = false;
    },
    save() {
      this.loading = true;
      CotacaoService.addFornecedor(this.cotacao.id, this.fornecedor.id)
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Fornecedor adicionado', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildInitialState() {
      this.fornecedor = null;
      this.$v.$reset();
    },
  },
  watch: {
    menuOpened() {
      if (!this.menuOpened) {
        return;
      }
      this.buildInitialState();
    },
  },
  validations: {
    fornecedor: {
      required,
    },
  },
};
</script>
